export const SEND_CALL = gql`
  mutation SEND_CALL(
    $applicantId: String!
    $companyId: String
    $employeeId: String
    $voiceAgentId: String
  ) {
    sendCall(
      applicantId: $applicantId
      companyId: $companyId
      employeeId: $employeeId
      voiceAgentId: $voiceAgentId
    ) {
      activityLogId
    }
  }
`

export const SEND_VOE_CALL = gql`
  mutation SEND_VOE_CALL(
    $voeId: String!
    $voiceAgentId: String
    $phoneNumber: String
  ) {
    sendVoECall(
      voeId: $voeId
      voiceAgentId: $voiceAgentId
      phoneNumber: $phoneNumber
    ) {
      activityLogId
    }
  }
`

export const GET_VOICE_SAMPLE_AUDIO = gql`
  query GET_VOICE_SAMPLE_AUDIO($voiceId: String!, $text: String) {
    voiceSampleAudio(voiceId: $voiceId, text: $text)
  }
`

export const GET_VOICE_AGENTS = gql`
  query GET_VOICE_AGENTS($pageInfo: PageInfoInput) {
    voiceAgents(pageInfo: $pageInfo) {
      items {
        voiceAgentId
        name
        direction
        voice
        status
        type
        provider
        updatedAt
        waitForGreeting
        sensitiveVoicemailDetection
        transferCall
        transferPhoneNumber
        skipCallReason
        skipQualificationQuestions
        skipKnowledgeBase
        autoProgress
        questionTemplates {
          questionTemplateId
          question
          variableName
          shortQuestionName
          variableType
          condition
          status
          disqualifiedReason
          createdAt
          updatedAt
        }
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
`

export const UPDATE_VOICE_AGENT = gql`
  mutation UPDATE_VOICE_AGENT(
    $voiceAgentId: String!
    $input: UpdateVoiceAgentInput!
  ) {
    updateVoiceAgent(voiceAgentId: $voiceAgentId, input: $input) {
      voiceAgentId
      name
      voice
      waitForGreeting
      sensitiveVoicemailDetection
      transferCall
      transferPhoneNumber
      skipCallReason
      skipQualificationQuestions
      skipKnowledgeBase
      autoProgress
      questionTemplates {
        questionTemplateId
        question
        variableName
        shortQuestionName
        variableType
        condition
        status
        disqualifiedReason
        createdAt
        updatedAt
      }
    }
  }
`

export const CREATE_VOICE_AGENT = gql`
  mutation CREATE_VOICE_AGENT($input: CreateVoiceAgentInput!) {
    createVoiceAgent(input: $input) {
      voiceAgentId
      name
      voice
    }
  }
`
